import { render, staticRenderFns } from "./richPage.vue?vue&type=template&id=20d3c830&scoped=true&"
import script from "./richPage.vue?vue&type=script&lang=js&"
export * from "./richPage.vue?vue&type=script&lang=js&"
import style0 from "./richPage.vue?vue&type=style&index=0&id=20d3c830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3c830",
  null
  
)

export default component.exports